/**
 * Shopify CDN image sizing – sharp thumbs without full scan downloads.
 */
(() => {
  const CDN_HOST = 'cdn.shopify.com';

  const isShopifyCdnUrl = (url) => {
    const raw = String(url || '').trim().toLowerCase();
    return raw.includes(CDN_HOST);
  };

  /** @param {string} url @param {number} width */
  const sizedUrl = (url, width) => {
    const raw = String(url || '').trim();
    if (!raw || !width) return raw;
    if (!isShopifyCdnUrl(raw)) return raw;
    try {
      const parsed = new URL(raw, window.location.origin);
      parsed.searchParams.set('width', String(Math.round(width)));
      return parsed.toString();
    } catch {
      const joiner = raw.includes('?') ? '&' : '?';
      return `${raw}${joiner}width=${Math.round(width)}`;
    }
  };

  /** @param {string} url @param {number[]} widths */
  const srcSet = (url, widths) => {
    if (!url || !Array.isArray(widths) || !widths.length) return '';
    return widths
      .map((w) => {
        const sized = sizedUrl(url, w);
        return sized ? `${sized} ${Math.round(w)}w` : '';
      })
      .filter(Boolean)
      .join(', ');
  };

  const WIDTHS = {
    cartThumb: 120,
    gridThumbSm: 180,
    gridThumb: 360,
    gridThumbMd: 540,
    gridThumbLg: 720,
    cardPreview: 600,
  };

  window.Kl24ShopifyImage = {
    isShopifyCdnUrl,
    sizedUrl,
    srcSet,
    WIDTHS,
  };
})();
